/*
window.addEventListener('DOMContentLoaded', function(){

    // apiのURL
    const API_PATH = '/apps/my-api/discount'

    // クーポン適用ボタンを有効化・無効化
    $('.coupon-input').on("input", function() {
console.log('test');
      let couponCode = $(this).val();
        // 有効化
        if (couponCode) {
            couponBtnEnable();
            // 無効化
        } else {
           couponBtnDisable();
        }
    });

    // 適用ボタンクリック時
    $('.coupon-btn').on("click", function() {
      let couponCode = $('.coupon-input').val();
        let customerId = $('#customer_id').val();

        // クーポン情報を取得
        $.ajax({
            url: API_PATH,
            type: 'POST',
            data: {
                code:couponCode,
                customerId:customerId
            },
            dataType: 'json',

        }).done(function(res) {
            let data = res.data;
            $.ajax({
                url: "/discount/" + data.code,
                type: 'GET',
            });
            // メッセージ表示
            couponSuccess(data);
        }).fail(function(res) {
            // メッセージ表示
            couponError(res.responseJSON.data.message);
        }).always(function(res) {
            // console.info(res);
        });
    });
  
    // クーポン適用 成功
    function couponSuccess(data) {
        $('.coupon-msg').removeClass('coupon-msg-error');
        $('.coupon-msg').addClass('coupon-msg-success');
        couponBtnDisable();
        $('.coupon-msg').text(data.message);
        $('.coupon-note').text(data.note);
    }
    // クーポン適用 失敗
    function couponError(message) {
        $('.coupon-msg').removeClass('coupon-msg-success');
        $('.coupon-msg').addClass('coupon-msg-error');
        $('.coupon-msg').text(message);
        $('.coupon-note').text('');
    }
    // クーポン入力欄 有効化
    function couponBtnEnable() {
        $('.coupon-btn').prop("disabled", false);
        $('.coupon-btn').addClass('active');
    }
    // クーポン入力欄 無効化
    function couponBtnDisable() {
        $('.coupon-btn').prop("disabled", true);
        $('.coupon-btn').removeClass('active');
    }
});


function coupon_test() {
  console.log('test');
}


function coupon_test2() {
  console.log('test2');
}
*/

// apiのURL
const API_PATH = '/apps/my-api/discount'

// クーポン適用ボタンを有効化・無効化
function coupon_input() {
  let couponCode = $('.coupon-input').val();
    // 有効化
    if (couponCode) {
        couponBtnEnable();
        // 無効化
    } else {
       couponBtnDisable();
    }
}

// 適用ボタンクリック時
function coupon_btn_click() {

console.log('click');
  
  let couponCode = $('.coupon-input').val();
    let customerId = $('#customer_id').val();

    // クーポン情報を取得
    $.ajax({
        url: API_PATH,
        type: 'POST',
        data: {
            code:couponCode,
            customerId:customerId
        },
        dataType: 'json',

    }).done(function(res) {
        let data = res.data;
        $.ajax({
            url: "/discount/" + data.code,
            type: 'GET',
        });
        // メッセージ表示
        couponSuccess(data);
    }).fail(function(res) {
        // メッセージ表示
        couponError(res.responseJSON.data.message);
    }).always(function(res) {
        // console.info(res);
    });
}

// クーポン適用 成功
function couponSuccess(data) {
    $('.coupon-msg').removeClass('coupon-msg-error');
    $('.coupon-msg').addClass('coupon-msg-success');
    couponBtnDisable();
    $('.coupon-msg').text(data.message);
    $('.coupon-note').text(data.note);
}
// クーポン適用 失敗
function couponError(message) {
    $('.coupon-msg').removeClass('coupon-msg-success');
    $('.coupon-msg').addClass('coupon-msg-error');
    $('.coupon-msg').text(message);
    $('.coupon-note').text('');
}
// クーポン入力欄 有効化
function couponBtnEnable() {
    $('.coupon-btn').prop("disabled", false);
    $('.coupon-btn').addClass('active');
}
// クーポン入力欄 無効化
function couponBtnDisable() {
    $('.coupon-btn').prop("disabled", true);
    $('.coupon-btn').removeClass('active');
}
